// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Rftq2","content":"styles_content__2r9G9"};